<template>
  <div class="coupon-list">
    <van-list
      v-model="loading"
      :finished="finished"
      finished-text="没有更多了"
      @load="getCardList"
      class="list">
      <div v-for="item in cardList" :key="item.id">
        <CardItem :value="item"/>
      </div>
    </van-list>
  </div>
</template>
 <script>
import { cardListApi } from '@/api/card';
import CardItem from './components/CardItem';
import { List } from 'vant'
 
export default {
  name: 'couponList',
  components: {
    CardItem,
    [List.name]: List
  },
  data() {
    return {
      cardList: [],
      loading: false,
      finished: false,
      page: 0
    }
  },
  methods: {
    async getCardList () {
      this.page++
      this.loading= true
      const result = await cardListApi({
        page: this.page,
        size: 10
      }).catch(err => {
        this.loading = false
        this.finished = true
      })
       this.loading = false
      const data = result.data.data
      if (data.status && data.list.data.length !== 0) {
        this.cardList = this.cardList.concat(data.list.data)
      } else {
        this.finished = true
      }
    }
  }
}
</script>
<style scoped>
.coupon-list{
  background: url('~@/assets/exchange/exchange-bg.png') 100%/100% no-repeat;
  min-height: 100vh;
}
</style>